import { useTranslation } from 'react-i18next'

import { EMPTY_OBJECT } from '../../../../constants/common'
import { Widget, WidgetContentItemsList } from '../../../Widget'
import { EmailProfileWidgetCustomFoldersItem } from '../EmailProfileWidgetCustomFoldersItem'

import { getCustomFolderListItemProps } from './EmailProfileWidgetCustomFolders.utils'

import * as styles from './EmailProfileWidgetCustomFolders.module.css'

function EmailProfileWidgetCustomFolders({
  folders,
  initiallyExpanded,
  isSkeleton,
  widgetProps: { className = styles.widget, ...widgetProps } = EMPTY_OBJECT,
}) {
  const { t } = useTranslation()

  return (
    <Widget
      {...widgetProps}
      className={className}
      headerProps={{
        contentProps: {
          actionsProps: {
            EditButton: null,
          },
        },
      }}
      initiallyExpanded={initiallyExpanded}
      isSkeleton={isSkeleton}
      title={t('EmailProfile.CustomFoldersWidgetTitleKey')}
    >
      <WidgetContentItemsList
        Item={EmailProfileWidgetCustomFoldersItem}
        getItemPropsFromValue={getCustomFolderListItemProps}
        itemProps={{
          backgroundColor: 'var(--color-bg-grey-deadline)',
          textColor: 'var(--secondary-text-color)',
        }}
        items={folders}
        title={t('EmailProfile.CustomFoldersWidgetListTitleKey', {
          count: folders?.length,
        })}
      />
    </Widget>
  )
}

export default EmailProfileWidgetCustomFolders
